"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFinalForm = require("react-final-form");

var _TextFieldAdapter = _interopRequireDefault(require("../../Adapters/TextFieldAdapter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrustURNField = function TrustURNField(_ref) {
  var required = _ref.required;

  var isValid = function isValid(value) {
    return !required && (!value || value.length === 0) || value ? undefined : "Please enter a Unique Reference Number";
  };

  return /*#__PURE__*/_react.default.createElement(_reactFinalForm.Field, {
    name: "trustURN",
    label: "Unique Reference Number",
    validate: isValid,
    component: _TextFieldAdapter.default,
    subscription: {
      touched: true,
      value: true,
      error: true
    },
    fullWidth: true,
    required: true
  });
};

var _default = TrustURNField;
exports.default = _default;